<style lang="sass" src="./layout.sass" scoped></style>

<template lang="pug">
.layout
  LayoutHeader(:header-bgc="headerBgc")
  .layout-body
    slot(name="page")
  LayoutFooter
</template>

<script>
import LayoutHeader from './header'
import LayoutFooter from './footer'

export default {
  name: 'layout',
  props: {
    headerBgc: {
      type: Boolean,
      default: false
    }
  },
  components: { LayoutHeader, LayoutFooter }
}
</script>



// WEBPACK FOOTER //
// layout.vue?3ba8d1a8